<template>
    <v-container grid-list-xs class="pa-0 ma-0" fluid>
      <v-row class="pa-0 ma-0 titlesdark--text">
        <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
          <span class="pl-1 text-light font-size-2">{{tituloGrids}}</span>
        </v-col>
      </v-row>
      <v-row class="pa-0 ma-0 mt-2">
        <v-col md="12" sm="12" class="pa-0 ma-0">
          <grid
            v-if="this.$store.state.token!=''"
            :tabla="TablaName"
            :bActiveFilter="true"
            :bActiveExport="true"
            :bSingleSelect="true"
            :bShowSelect="false"
            :sIdTable="'idInfoCarousel'"
            :bShowMapDetails="false"
            :bActiveNew="true"
            :aInfoTBDetalleExp="aDetallesExport"
            >
          </grid>  
        </v-col>
      </v-row>
  
    </v-container>
  </template>
  
  <script>
  import grid from '@/components/Grid/Grid.vue'
  import mxFunciones from '@/mixins/funciones.js'
  // import DialogFirmas from '@/components/DialogFirmas.vue'
  
  export default {
    name: 'InfoCarousel',
    components: {
      grid
    },
    mixins: [mxFunciones],
    data() {
      return {
        TablaName : 'InfoCarousel',    // Nombre de la tabla a trabajar
        nIdSeleccionado  : 0,                 // Id seleccionado
        sNombreCampoFiltro : '',                 // Nombre del campo foreignKey
        oItemSeleccionado: {},
        nKeyReset : 0,
        aDetallesExport : [],
      }
    },
    async mounted() {
      this.onValidarTokenSinLogin()
      this.tituloGrids = await this.getTitulo(this.TablaName)
    },
    methods: {
    },
  }
  </script>
  
  <style lang="scss" scoped>
  
  </style>